import React from 'react';
import { styled } from '@compiled/react';
import { SpotlightCard } from '@atlaskit/onboarding';
import { useIntl, FormattedMessage } from '@atlassian/jira-intl';
import messages from '../../../../../common/messages.tsx';
import type { SpotlightContainerProps } from './types.tsx';

export const SpotlightContainer = ({
	shouldShowSpotlight,
	onCloseSpotlight,
}: SpotlightContainerProps) => {
	const { formatMessage } = useIntl();

	return (
		<SpotlightPopoverWrapper data-testid="issue-create.ui.modal.modal-wrapper.minimizable-modal-mini.modal-spotlight.wrapper">
			{shouldShowSpotlight && (
				<SpotlightCard
					heading={formatMessage(messages.miniModalSpotlightHeading)}
					width={290}
					actions={[
						{
							onClick: onCloseSpotlight,
							text: formatMessage(messages.miniModalSpotlightActionMessage),
						},
					]}
				>
					<FormattedMessage
						{...messages.miniModalSpotlightMessage}
						values={{
							br: (
								<>
									<br />
									<br />
								</>
							),
						}}
					/>
				</SpotlightCard>
			)}
		</SpotlightPopoverWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpotlightPopoverWrapper = styled.div({
	position: 'absolute',
	top: '0px',
	left: '-282px',
});
